export default "/images/clear.svg"